import Filter from './filter';
import {FILTER_TYPE_NUMBER} from 'src/js/lib/filtering/filters_definitions_constants';

class NumberFilter extends Filter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_NUMBER;
  }

  static fromString(serializedFilter) {
    const nameValueSepIdx = serializedFilter.indexOf(':');
    const property = serializedFilter.slice(0, nameValueSepIdx);
    if (serializedFilter.slice(nameValueSepIdx + 1) === '*') {
      return new NumberFilter({property, value: null});
    }
    // remove parenthesis
    let value = serializedFilter.slice(nameValueSepIdx + 2, -1);
    value = value != null ? parseFloat(value) : null;
    return new NumberFilter({property, value});
  }

  static fromSchema(schemaNode) {
    return new NumberFilter({property: schemaNode.getName()});
  }

  clone() {
    return new NumberFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  getValue() {
    return this.value;
  }

  isEqual(otherFilter) {
    return this.property === otherFilter.property;
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value}'`;
    }
    return `${this.property}:*`;
  }

  toComponentString(filterSchema, translateService) {
    const node = filterSchema.getFilterByName(this.property);
    const label = translateService
      ? translateService.formatMessage({id: node.getLabel()})
      : node.getLabel();
    return `${label}: ${this.value}`;
  }
}

export default NumberFilter;
